import { computedFn } from 'mobx-utils/lib/computedFn';
import type { ComposeViewState } from 'owa-mail-compose-store';
import { RibbonGroupId } from 'owa-ribbon-ids';
import type { Layout } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/components/RibbonControlGroupMLR';

export const getMLRViewTabGroupLayouts = computedFn(
    (group: RibbonGroupId, popoutComposeViewState?: ComposeViewState): Layout[] | undefined => {
        // View tab has no group layouts
        return undefined;
    }
);
